import { render, staticRenderFns } from "./BuildRequestDialog.vue?vue&type=template&id=3f7c1952&lang=pug&"
import script from "./BuildRequestDialog.vue?vue&type=script&lang=ts&"
export * from "./BuildRequestDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports